var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import Button from './Button';
import SnackBar from './Snackbar';
const CopyButton = props => {
    const { value, successMessage, onClick } = props, rest = __rest(props, ["value", "successMessage", "onClick"]);
    const [copied, setCopied] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(SnackBar, { show: copied, delay: 2000, onHideSnackbar: () => setCopied(false) }, successMessage),
        React.createElement(Button, Object.assign({}, rest, { onClick: e => {
                copy(value);
                setCopied(true);
                if (onClick) {
                    onClick(e);
                }
            } }), props.children || 'Copy')));
};
CopyButton.propTypes = Object.assign({ value: PropTypes.string, successMessage: PropTypes.string }, Button.propTypes);
CopyButton.defaultProps = {
    successMessage: 'Copied successfully.',
};
export default CopyButton;
